<script>
	const model = require('model/model');
	const utilities = require('utilities');
	const classUtilities = require('utilities/classUtilities');

	const unarchiveClass = classUtilities.unarchiveClass;
	const CLASS_STATUS_MAP = classUtilities.STATUS_MAP;

	const { authenticateWithGoogleClassroom /* isKnownGoogleClass */ } = require('utilities/googleClassroomUtilities');

	const { assetUrl } = require('utilities/urlUtilities');

	module.exports = {
		props: ['classes', 'archiveDate', 'loadingClasses'],
		modelData: {
			classAdmin: 'currentTab',
			userContext: 'userContext',
			localGCAccessToken: 'localGCAccessToken',
			gcClassList: 'gcClassList'
		},
		components: {
			'tab-container': require('components/tab-container.vue').default
		},
		computed: {
			classView: function () {
				let classes = this.classes || [];
				let tab = this.currentTab;
				let filter = CLASS_STATUS_MAP[tab] || 'a';

				return classes
					.filter(c => {
						if (filter === CLASS_STATUS_MAP.archived) {
							return c.uid === this.userContext.uid && c.status === filter;
						} else {
							return c.status === filter;
						}
					})
					.map(c => {
						// if (c.gcid) {
						// 	c.gcMismatch = !this.gcClassList || !isKnownGoogleClass(c.gcid);
						// }
						return c;
					});
			},
			hasArchivedClasses: function () {
				const classes = this.classes || [];
				const filter = CLASS_STATUS_MAP.archived;
				const userContext = this.userContext;
				const uid = userContext && userContext.uid;

				return classes.some(c => c.uid === uid && c.status === filter);
			}
		},
		watch: {
			classView: function (val) {
				if (!val || !val.length) {
					model.set('classAdmin', 'active');
				}
			}
		},
		methods: {
			onArchiveClassClick: function (clazz) {
				utilities.openModal('#modal-archive-class', {
					clazz
				});
			},
			onDeleteClassClick: function (clazz) {
				utilities.openModal('#modal-delete-class', {
					clazz
				});
			},
			importFromGoogleClassroom() {
				if (!this.localGCAccessToken) {
					authenticateWithGoogleClassroom();
				} else {
					utilities.openModal('#modal-google-classroom-import');
				}
			},
			authenticateWithGoogleClassroom,
			unarchiveClass,
			assetUrl
		}
	};
</script>
<style lang="scss">
	.class-list {
		.main-header {
			padding: 1rem 0 0 0;

			.main-header-title {
				margin-bottom: 1rem;
			}
		}
		.tab-container button {
			margin-top: 0rem;
		}
		.google-icon {
			width: 32px;
		}
	}
</style>
<template>
	<div class="class-list">
		<header class="main-header">
			<div class="wrapper">
				<h1 class="main-header-title">Classes</h1>
				<ul class="main-header-actions">
					<li v-if="!(userContext && userContext.organization)">
						<button
							data-modal="#modal-create-class"
							class="button -outline">
							&plus; Create a Class
						</button>
					</li>
				</ul>
				<tab-container
					v-if="hasArchivedClasses"
					model-key="classAdmin">
					<button data-tab="active">Current Classes</button>
					<button
						data-tab="archived"
						:class="[!hasArchivedClasses]">
						Archived Classes
					</button>
				</tab-container>
			</div>
		</header>
		<div
			class="main-content wrapper"
			ref="classAdminPanel"
			:data-panel="currentTab">
			<table v-if="!loadingClasses && classView.length > 0">
				<caption v-if="!(userContext && userContext.organization)">
					Manage your classes or create new ones.
				</caption>
				<thead>
					<tr v-if="currentTab !== 'archived'">
						<th>Class</th>
						<th>&nbsp;</th>
						<th v-if="!(userContext && userContext.organization)">Class Code</th>
						<th>Students</th>
					</tr>
					<tr v-if="currentTab === 'archived'">
						<th>Class</th>
						<th v-if="!(userContext && userContext.organization)">Class Code</th>
						<th>&nbsp;</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-if="currentTab !== 'archived'"
						v-for="clazz in classView"
						:key="clazz.classCode">
						<th>
							<a :href="`/class-admin#!classAdmin:roster/classCode:${clazz.classCode}`">
								{{ clazz.name }}
							</a>
							<button
								v-if="clazz.gcid"
								class="button -link google-classroom-button"
								:class="{
									mismatch: clazz.gcMismatch
								}"
								@click="clazz.gcMismatch && authenticateWithGoogleClassroom()"
								v-tooltip="clazz.gcMismatch ? 'Please authenticate the Google account used to manage this Classroom' : 'Google Classroom'">
								<i
									v-if="clazz.gcMismatch"
									class="mismatch-icon fa-solid fa-circle-exclamation"
									aria-hidden="true"></i>
								<img
									class="google-icon"
									:src="assetUrl('/assets/dist/images/google-classroom/gc_square_color_32.png')"
									alt="" />
							</button>
						</th>
						<td class="text-muted">
							<div
								v-if="clazz.created < archiveDate && userContext && clazz.uid === userContext.uid"
								class="button -reverse"
								@click="onArchiveClassClick(clazz)">
								Archive
							</div>
						</td>
						<td v-if="!(userContext && userContext.organization)">
							{{ clazz.classCode }}
						</td>
						<td
							v-if="clazz.studentCount > 0"
							class="text-muted">
							{{ clazz.studentCount }} {{ clazz.studentCount > 1 ? 'Students' : 'Student' }}
						</td>
						<td
							v-if="clazz.studentCount === 0 && clazz.rosterType === 'student'"
							class="text-muted">
							<a
								:href="`/class-admin#!classAdmin:invite/classCode:${clazz.classCode}`"
								class="button"
								>Invite Students</a
							>
						</td>
						<td
							v-if="clazz.studentCount === 0 && clazz.rosterType !== 'student'"
							class="text-muted">
							0 Students
						</td>
					</tr>
					<tr
						v-if="currentTab === 'archived'"
						v-for="clazz in classView"
						:key="clazz.classCode">
						<th>
							<span>{{ clazz.name }}</span>
							<button
								v-if="clazz.gcid"
								class="button -link"
								v-tooltip="'Google Classroom'">
								<img
									class="google-icon"
									:src="assetUrl('/assets/dist/images/google-classroom/gc_square_color_32.png')"
									alt="" />
							</button>
						</th>
						<td>{{ clazz.classCode }}</td>
						<td class="text-muted">
							<span
								class="button"
								@click="unarchiveClass(clazz)"
								>Unarchive</span
							>
							<span
								class="button -danger"
								@click="onDeleteClassClick(clazz)"
								>Delete</span
							>
						</td>
					</tr>
				</tbody>
			</table>
			<template v-if="!loadingClasses && classView.length === 0">
				<h2>Create your first Class</h2>
				<p>You need a class so you can create assignments for students.</p>
				<button
					data-modal="#modal-create-class"
					class="button">
					Create a Class
				</button>
			</template>
			<p v-if="loadingClasses">
				Loading your classes...
				<img
					:src="assetUrl('/assets/dist/images/loader.gif')"
					alt="Loading"
					role="presentation" />
			</p>
		</div>
	</div>
</template>
